import Root from "./Root";
import { inject } from "mobx-react";

export default inject((stores: any, props: any, context: any): any => ({
	isAuthenticating: stores.sessionStore.isAuthenticating,
	isAuthError: stores.sessionStore.isAuthError,
	hasDataAccess: stores.sessionStore.isUserAllowed("read:data"),
	history: stores.navigationStore.history
}))(Root);
